import { ContextPack } from "@/api/studio/contexts/types/context.type";
import { Point } from "@/api/studio/data/types/point.type";
import { useEffect, useState } from "react";

/* Constants */
export const DEFAULT_DROPZONE_BACKGROUND = "#FFFFFF";
export const TRANSPARENT_DROPZONE_BACKGROUND = "#FFFFFF00";

/*
 * useDropzone hook
 */
export const useDropzone = (contextPack?: ContextPack, assetIndex?: number) => {
  /* State */
  const [dropzoneBackground, setDropzoneBackground] = useState<string>(DEFAULT_DROPZONE_BACKGROUND);
  const [showDropzoneBackground, setShowDropzoneBackground] = useState(false);
  const [points, setPoints] = useState<Point[]>([]);
  const [dropzoneId, setDropzoneId] = useState<string>("");

  /* Side effects */
  useEffect(() => {
    if (contextPack && assetIndex !== undefined && contextPack.contexts[assetIndex]?.dropzone?.points) {
      // set the default dropzone details if they exist on the context
      const { points, backgroundColor } = contextPack.contexts[assetIndex].dropzone;
      // a transparent background means fill is off - keep a valid hex for the colour picker so re-enabling fill defaults to white
      const isTransparent = !backgroundColor || backgroundColor.toUpperCase() === TRANSPARENT_DROPZONE_BACKGROUND;
      setPoints(points);
      setDropzoneBackground(isTransparent ? DEFAULT_DROPZONE_BACKGROUND : backgroundColor);
      setShowDropzoneBackground(!isTransparent);
    }
  }, [contextPack, assetIndex]);

  /* Handlers */
  const resetDropzoneBackground = () => {
    setDropzoneBackground(DEFAULT_DROPZONE_BACKGROUND);
    setShowDropzoneBackground(false);
  };

  /* Derived */
  const dropzoneBackgroundValue = showDropzoneBackground ? dropzoneBackground : TRANSPARENT_DROPZONE_BACKGROUND;

  /* Return */
  return {
    points,
    setPoints,
    dropzoneId,
    setDropzoneId,
    dropzoneBackground,
    setDropzoneBackground,
    showDropzoneBackground,
    setShowDropzoneBackground,
    resetDropzoneBackground,
    dropzoneBackgroundValue,
  };
};
